import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import galleryData from "../data/newgallery.json"; 
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { ReactComponent as LeftArrow } from "../assets/icons/left-arrow.svg"; 
import { ReactComponent as RightArrow } from "../assets/icons/right-arrow.svg"; 
import '../styles/galleryStyles.css'
import seoFriendlySlug from "../utils/seoFriendlySlug";

const Gallery = () => { 
  const isUAEPath = window.location.pathname.startsWith("/uae");
    const currentLocation = useLocation();
  
    const basePath = currentLocation.pathname.startsWith("/uae")
    ? "/uae"
    : "/";
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const sliderRef = useRef(null); 

  useEffect(() => {
    
    setCategories(galleryData.gallery); 
  }, []);

  let settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0",
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
    ],
  };

  const getImageUrl = (imageName) => {
    const baseUrl = "https://timewatch.co.in/gallery/";  // Prepend this base URL to the image path
    return baseUrl + imageName;  // Returns the full URL for the image
  };
  
  const gallery = `${basePath}gallery`;

  const handleCardClick = (heading) => {
    navigate(`${basePath}gallery/${seoFriendlySlug(heading)}`);
  };

  const nextSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const prevSlide = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  return (
    <div className="carousel-container" style={{maxWidth: '2000px'}}>
      <div className="carousel-heading">Our Culture</div>
      <div className="carousel">
        <Slider ref={sliderRef} {...settings}>
          {categories.map((category, index) => {
            const imageUrl = getImageUrl(category.heroimg); 

            return (
              <div
                key={index}
                className="card"
                onClick={() => {
                  handleCardClick(category.heading); 
                  scrollToTop();
                }}
                style={{ cursor: "pointer", transform: 'none' }}
              >
                <img
                  src={imageUrl}
                  alt={category.heading}
                  style={{
                    width: "100%",
                    height: "300px",
                    objectFit: "cover",
                    transform: 'none'
                  }}
                />
                <h3 style={{ textAlign: "center", marginTop: "10px" }}>
                  {category.heading} {}
                </h3>
              </div>
            );
          })}
        </Slider>
        <button
          className="nav-button left"
          onClick={prevSlide}
          style={{
            position: "absolute",
            left: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "rgba(255, 255, 255, 0.8)",
            border: "none",
            cursor: "pointer",
            borderRadius: "50%",
            padding: "10px",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)",
            transition: "background 0.3s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.background = "rgba(255, 255, 255, 1)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = "rgba(255, 255, 255, 0.8)")
          }
        >
          <LeftArrow width={20} height={20} />
        </button>
        <button
          className="nav-button right"
          onClick={nextSlide}
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            basckground: "rgba(255, 255, 255, 0.8)",
            border: "none",
            cursor: "pointer",
            borderRadius: "50%",
            padding: "10px",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)",
            transition: "background 0.3s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.background = "rgba(255, 255, 255, 1)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = "rgba(255, 255, 255, 0.8)")
          }
        >
          <RightArrow width={20} height={20} />
        </button>
      </div>
    </div>
  );
};

export default Gallery;
